<!-- eslint-disable vue/no-v-html -->
<template>
  <span
    v-if="!custom"
    aria-hidden="true"
    class="material-symbols-outlined c-icon notranslate"
    :class="{
      [`c-icon--${size}`]: size,
      [`c-icon--${variant}`]: variant,
    }"
    :title="title"
  >
    {{ name }}
  </span>

  <div
    v-else
    aria-hidden="true"
    class="c-icon"
    :class="{
      [`c-icon--${size}`]: size,
      [`c-icon--${variant}`]: variant,
    }"
    v-html="svg"
  />
</template>

<script setup lang="ts">
import { ref, computed, watch } from 'vue'

interface Props {
  name?: string
  size?: 'xs' | 'small' | 'medium' | 'large'
  title?: string
  variant?: 'default' | 'filled'
}

const props = withDefaults(defineProps<Props>(), {
  name: '',
  size: 'small',
  title: undefined,
  variant: 'default',
})

const svg = ref('')

const custom = computed(() => {
  return (
    [
      'fastenings',
      'sprinkler',
      'vvs-industri',
      'verktyg',
      'mark-va',
      'fastighet',
      'kyla',
      'el',
    ].indexOf(props.name) > -1
  )
})

const loadSvg = async () => {
  const { default: SvgComponent } = await import(
    `../../../icons/${props.name}.svg`
  )
  svg.value = SvgComponent
}

if (custom.value) {
  loadSvg()
}

watch(
  () => props.name,
  () => {
    if (custom.value) {
      loadSvg()
    }
  },
)
</script>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'CIcon',
})
</script>
